import React, { useState, useEffect } from 'react';
import './Providers.scss';
import Table from './components/Table/Table';
import { getAllProvidersByCompanyId, getAllProviderCategoriesByCompanyId } from '../../../../crud/management_api/providers';
import { Provider, ProviderCategories } from './types';
import LoadingSpinner from '../../../../components/common/LoadingSpinner';
import { CategoriesOption, getCategoriesOptions } from './components/Table/components/utils/functions';
import { MPPageTitle } from '../../../../components/ui';
import { toast } from 'react-toastify';

const Providers: React.FC = () => {
  const [providers, setProviders] = useState<Provider[]>([]);
  const [providersCategory, setProvidersCategory] = useState<ProviderCategories[]>([]);
  const [loading, setLoading] = useState(true);
  const [categories, setCategories] = useState<CategoriesOption[]>([]);
  const [filteredProvider, setFilteredProvider] = useState<Provider[]>([]);
  const [selectedCategorie, setSelectedCategorie] = useState<any[]>([]);

  useEffect(() => {
    (async () => {
      const fetchedCategories = await getCategoriesOptions();
      setCategories(fetchedCategories);
    })();
  }, []);

  useEffect(() => {
    const userContext = localStorage.getItem('user');
    const companyId = userContext ? JSON.parse(userContext).company_id : 0;
    getAllProvidersByCompanyId(companyId)
      .then(response => {
        setProviders(response.data);
        setFilteredProvider(response.data);
      })
      .catch(console.error)
      .finally(() => setLoading(false));
  }, []);

  useEffect(() => {
    const userContext = localStorage.getItem('user');
    const companyId = userContext ? JSON.parse(userContext).company_id : 0;
    getAllProviderCategoriesByCompanyId(companyId)
      .then(response => {
        if (!response.data || response.data.length === 0) {
          toast.error('No existen categorías de proveedor');
        }
        setProvidersCategory(response.data);
      })
      .catch(error => {
        if (error?.response?.status === 404) {
          toast.error('No existen categorías de proveedor');
        } else {
          toast.error('Error al obtener las categorías de proveedor');
          console.error(error);
        }
      });
  }, []);

  const CategorieOptions = categories.map(p => ({ value: p.id, label: p.name }));

  useEffect(() => {
    const filtered = providers.filter(provider =>
      selectedCategorie.length === 0 ||
      selectedCategorie.some(option => option.value === provider.categories?.[0]?.category_id)
    );
    setFilteredProvider(filtered);
  }, [providers, selectedCategorie]);

  const refreshCategories = async () => {
    const fetchedCategories = await getCategoriesOptions();
    setCategories(fetchedCategories);
    const userContext = localStorage.getItem('user');
    const companyId = userContext ? JSON.parse(userContext).company_id : 0;
    const response = await getAllProviderCategoriesByCompanyId(companyId);
    setProvidersCategory(response.data || []);
  };

  if (loading) {
    return <LoadingSpinner text="Cargando proveedores" />;
  }

  return (
    <div className="flex flex-col gap-4 p-3 lg:gap-5 lg:p-4" style={{ height: 'calc(100vh - 56px)', overflow: 'hidden' }}>
      <MPPageTitle>Proveedores</MPPageTitle>
      <div className="flex flex-col gap-3 flex-1 min-h-0 overflow-hidden">
        <Table
          providers={filteredProvider}
          categories={categories}
          providerCategories={providersCategory}
          setProviders={setProviders}
          selectedCategorie={selectedCategorie}
          setSelectedCategorie={setSelectedCategorie}
          CategorieOptions={CategorieOptions}
          onCategoriesChanged={refreshCategories}
        />
      </div>
    </div>
  );
};

export default Providers;
